import React from 'react';

const TourClients = () => ({
  run: false,
  stepIndex: 0,
  steps: [
    {
      content: (
        <>
          <p>
            En esta sección podrás ver los distintos estudiantes de una unidad y
            curso
          </p>
          <p>
            Esta sección se auto-completa con la información recibida, no puede
            editarse ni eliminarse ningún campo directamente
          </p>
        </>
      ),
      placement: 'center',
      styles: {
        options: {
          width: 900,
        },
      },
      target: 'body',
      title: 'Gestión de estudiantes',
    },
    {
      title: 'Puedes reiniciar el tour',
      content: (
        <div>
          <h3>Con este botón empieza de nuevo el tour</h3>
        </div>
      ),
      target: '.demo__segundo',
      placement: 'bottom',
    },
    {
      title: 'Este es el listado de estudiantes disponible',
      content:
        'En este apartado podrás llevar a cabo acciones relacionadas con tus estudiantes',
      target: '.RaList-main-43',
      placement: 'bottom',
    },
    {
      title: 'Cabecera de la tabla',
      content:
        'Haz click en alguno de los campos para ordenar de manera ascendente o descendente',
      target: '.RaDatagrid-headerRow-75',
      placement: 'bottom',
    },
    {
      title: 'Campo de búsqueda',
      content: 'Aquí podrás buscar por el nombre del cliente',
      target: '#q',
      placement: 'bottom',
    },
    {
      title: 'Añadir filtros',
      content: 'Aqui podrás añadir un nuevo filtro para refinar la búsqueda',
      target: '[aria-label="Añadir filtro"]',
      placement: 'bottom',
    },
    {
      title: 'Exportar listado de estudiantes',
      content: 'Aqui podrás esportyar en formato CSV el listado de estudiantes',
      target: '[aria-label="Exportar"]',
      placement: 'bottom',
    },
  ],
});

export default TourClients;
